<!-- Accordian  -->
<div class="ctm-tab custom-card overflow-none">
  <!-- bg-grey -->
  <div class="card-accord scrollbar app ">


    <ngb-accordion #a="ngbAccordion" [activeIds]="openPanels">
      <ngb-panel id="first" *ngIf="_isAfx" [activeIds]="openPanels">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblGeneralInfo 
              <span *ngIf="appointmentDetails" class="font16 ml-4">{{appointmentDetails.dealerName}} -
                {{appointmentDetails.chassisNo}}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                *ngIf="commonService.contactDetails?.isRentalCarSelected && commonService.RentalCarModel?.length > 0 && !commonService.appointmentDetails.noNeedTransport && !commonService.appointmentDetails.needTransportTicket"
                class="border-left border-dark pl-3 font16 "><strong translate>lblRentalCars</strong> :
                {{commonService.RentalCarModel}} - {{commonService.RentalCarPrice}}</span>
              <ng-container *ngIf="!a.activeIds.includes('first')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('first')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>

        <ng-template ngbPanelContent style="display: flex;">
          <app-work-order-general-info (isRefreshTab)="refreshTab($event)" (onShiftAppointment)="onRefresh()"
            (onGetContactDetails)="onGetContactDetail($event)">
          </app-work-order-general-info>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="first" *ngIf="_isBnh" [activeIds]="openPanels">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblGeneralInfo
              <span *ngIf="appointmentDetails" class="font16 ml-4">{{appointmentDetails.dealerName}} -
                {{appointmentDetails.chassisNo}}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                *ngIf="commonService.contactDetails?.isRentalCarSelected && commonService.RentalCarModel?.length > 0"
                class="border-left border-dark pl-3 font16 "><strong translate>lblRentalCars</strong> :
                {{commonService.RentalCarModel}} - {{commonService.RentalCarPrice}}</span>
              <ng-container *ngIf="!a.activeIds.includes('first')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('first')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-bnh-appointment-general-information [isWorkOrderHistory]="false" (isRefreshTab)="refreshTab($event)"
            (updatedAppointmentDetails)="updateAppointmentValues($event)"
            (onGetContactDetails)="onGetContactDetail($event)"
            (unselectRentalCar)="unselectRentalCar($event)">
          </app-bnh-appointment-general-information>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="first" *ngIf="_isMg" [activeIds]="openPanels">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblGeneralInfo
              <span *ngIf="appointmentDetails" class="font16 ml-4">{{appointmentDetails.dealerName}} -
                {{appointmentDetails.chassisNo}}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                *ngIf="commonService.contactDetails?.isRentalCarSelected && commonService.RentalCarModel?.length > 0"
                class="border-left border-dark pl-3 font16 "><strong translate>lblRentalCars</strong> :
                {{commonService.RentalCarModel}} - {{commonService.RentalCarPrice}}</span>
              <ng-container *ngIf="!a.activeIds.includes('first')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('first')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-mg-appointment-general-information [isWorkOrderHistory]="false" (isRefreshTab)="refreshTab($event)"
            (updatedAppointmentDetails)="updateAppointmentValues($event)"
            (onGetContactDetails)="onGetContactDetail($event)"
            (unselectRentalCar)="unselectRentalCar($event)">
          </app-mg-appointment-general-information>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="fifth" *ngIf="_isAfx">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblAppointmentDetails
              <ng-container *ngIf="!a.activeIds.includes('second')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('second')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-appointment-details *ngIf="IsActive" [isWorkOrderHistory]="false"
            (updatedAppointmentDetails)="updateAppointmentValues($event)">
          </app-work-order-appointment-details>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="fifth" *ngIf="_isBnh">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblAppointmentDetails
              <ng-container *ngIf="!a.activeIds.includes('second')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('second')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-bnh-work-oder-appointment-details [contactDetails]="contactDetails" [isWorkOrderHistory]="false"
            (onShiftAppointment)="onRefresh()" (updatedAppointmentDetails)="updateAppointmentValues($event)">
          </app-bnh-work-oder-appointment-details>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="fifth" *ngIf="_isMg">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblAppointmentDetails
              <ng-container *ngIf="!a.activeIds.includes('second')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('second')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-mg-work-oder-appointment-details [contactDetails]="contactDetails" [isWorkOrderHistory]="false"
            (onShiftAppointment)="onRefresh()" (updatedAppointmentDetails)="updateAppointmentValues($event)">
          </app-mg-work-oder-appointment-details>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="sixth">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblCustomerDetails
              <span *ngIf="appointmentDetails && contactDetails" class="font16 ml-4">({{contactDetails.customerName}} - {{contactDetails.mobileNo}} - {{contactDetails.email}})</span>
              <button  type="button" class="btn btn-outline-primary ml-auto" translate aria-label="Center Align" *ngIf="userRoleRightsDetails.canEdit" (click)="viewCustomer(1,$event)"> lblSellToCustomer </button>
              <button  type="button" class="btn btn-outline-primary ml-2" translate aria-label="Center Align" *ngIf="userRoleRightsDetails.canEdit" (click)="viewCustomer(2,$event)"> lblBillToCustomer </button>
              <button  type="button" class="btn btn-outline-primary ml-2" translate aria-label="Center Align" *ngIf="userRoleRightsDetails.canEdit" (click)="confirmRefresh(true,$event)"> <em class="fas fa-sync fa-lg"></em> </button>
              <ng-container *ngIf="!a.activeIds.includes('sixth')"><em class="fas fa-angle-down fa-lg ml-2"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('sixth')"><em class="fas fa-angle-up fa-lg ml-2"></em>
              </ng-container>

            </button>

          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-customer-details [contactDetails]="contactDetails"
            (updatedContactDetails)="contactDetails=$event" #workOrderCustomerDetails (refreshCustomer)="onRefreshCustomer()">
          </app-work-order-customer-details>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="third">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblVehicleDetails
              <span *ngIf="contactDetails" class="font16 ml-4">({{contactDetails.licensePlate}} -
                {{appointmentDetails.brandCode}} - {{contactDetails.modelName}} - {{contactDetails.registrationDate}} - {{contactDetails.year}} - {{contactDetails.engineTypeCode}})</span>
                <button  type="button" class="btn btn-outline-primary ml-auto" translate aria-label="Center Align" *ngIf="userRoleRightsDetailsVehicle.canEdit"  (click)="viewVehicle($event)"> lblVehicleDetails </button>
                <button  type="button" class="btn btn-outline-primary ml-2" translate aria-label="Center Align" *ngIf="userRoleRightsDetails.canEdit" (click)="confirmRefresh(false,$event)"> <em class="fas fa-sync fa-lg"></em> </button>
                <ng-container *ngIf="!a.activeIds.includes('third')"><em class="fas fa-angle-down fa-lg ml-2"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('third')"><em class="fas fa-angle-up fa-lg ml-2"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-vehicle-details [contactDetail]="contactDetails">
          </app-work-order-vehicle-details>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="seventh" *ngIf="isGiftCardActive">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblGiftCards
              <ng-container *ngIf="!a.activeIds.includes('seventh')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('seventh')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-gift-card-details [giftCards]="contactDetails.giftCards">
          </app-work-order-gift-card-details>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="forth">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
              aria-label="Center Align">
              lblServices
              <span class="font16 ml-4 text-left">(<span>
                  <span translate>lblTotalPrice<span translate>lblInclVAT</span></span>:
                  {{workOrderService.totalPriceInclVAT | number:'1.2-2'}}</span>,&nbsp;
                <span *ngIf="workOrderService.taxDetail">
                  <span translate>lblVAT</span>(<span>{{VAT}}</span>%):
                  {{workOrderService.taxDetail.vatPrice | number:'1.2-2'}}</span>
                <span class="bold">,&nbsp;<span translate>lblTotalInvoice</span>:
                  {{workOrderService.totalInvoicePrice | number:'1.2-2'}}
                </span>
                <span class="bold">,&nbsp;<span translate>lblOverallAmount</span>:
                  {{workOrderService.overAllAmountInclTAX | number:'1.2-2'}}
                </span>
                <span>,&nbsp;<span translate>lblTotalTime</span>: {{formattedTotalTime}} <span
                    *ngIf="workOrderService.totalTime" translate>lblhr</span></span>)</span>
              <ng-container *ngIf="!a.activeIds.includes('forth')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
              </ng-container>
              <ng-container *ngIf="a.activeIds.includes('forth')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
              </ng-container>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-services #workOrderServices [appointmentServiceDetail]="serviceDetail" [contactDetails]="contactDetails" [isOpenFromPlanning]="isOpenFromPlanning"
            (updateServiceDetail)="updateService($event)" (openNewAppointment)="openNewAppointment($event)" (checkForSaveAppointment)="checkForSaveAppointment()">
          </app-work-order-services>
        </ng-template>
      </ngb-panel>



    </ngb-accordion>

    <ngb-accordion #acc="ngbAccordion" [activeIds]="openPanels" style="display: none;">
      <ngb-panel id="2">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div (click)="togglePanel(2)" translate class="d-flex w-100 align-items-center">
            <em class="fas fa-chevron-right mr-2"></em> lblVehicleDetails<span *ngIf="contactDetails"
              class="font16 ml-auto">
              ({{contactDetails.licensePlate}} - {{contactDetails.modelName}})</span>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-vehicle-details [contactDetails]="contactDetails">
          </app-work-order-vehicle-details>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="3">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div (click)="togglePanel(3)" translate class="d-flex w-100 align-items-center">
            <em class="fas fa-chevron-right mr-2"></em> lblServices <span class="font16 ml-auto">(<span>
                <span translate>lblTotalPrice</span>:
                {{workOrderService.totalPrice | number:'1.2-2'}}</span>
              <span>,&nbsp;<span translate>lblTotalInvoice</span>:
                {{(workOrderService.totalInvoicePrice - ((workOrderService.totalInvoicePrice *
                workOrderService.contactDetails?.discount)/100)) | number:'1.2-2'}}
              </span>
              <span>,&nbsp;<span translate>lblTotalTime</span>: {{formattedTotalTime}} <span
                  *ngIf="workOrderService.totalTime" translate>lblhr</span></span>)</span>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-work-order-services [appointmentServiceDetail]="serviceDetail" [isOpenFromPlanning]="isOpenFromPlanning">
          </app-work-order-services>
        </ng-template>
      </ngb-panel>

    </ngb-accordion>

  </div>
  <div class="p-3 bg-light pp-footer-top-brdr">


    <div class="d-flex flex-sm-row flex-column justify-content-end">
      <button class="btn btn-primary mr-sm-2 btn-lg" (click)="SaveAppointmentData()"
        *ngIf="(editAppointmentService.isEdit)"
        [disabled]="isSaving || workOrderService.isSavingAppointment(editAppointmentService.appointmentDetails.id) || !workOrderService.demandQtyCheckflag || workOrderService.isDisableSaveButton || workOrderService.isJobDetailDiscountError"
        translate aria-label="Center Align">
        <em class="far fa-save font16 align-top mr-2"></em>
        lblSave</button>
      <button class="btn btn-primary mr-sm-2 btn-lg" (click)="SaveAppointmentData(true)"
        *ngIf="(editAppointmentService.isEdit)"
        [disabled]="isSaving || workOrderService.isSavingAppointment(editAppointmentService.appointmentDetails.id) || !workOrderService.demandQtyCheckflag || workOrderService.isDisableSaveButton || workOrderService.isJobDetailDiscountError"
        translate aria-label="Center Align">
        <em class="far fa-save font16 align-top mr-2"></em>lblSaveAndClose
      </button>
      <button class="btn btn-primary mr-sm-2 btn-lg" *ngIf="!editAppointmentService.isEdit && editAppointmentService.appointmentDetails.isFromArchive"
        (click)="reOpenAppointment(reOpenAppointmentmodal)"
        [disabled]="!editAppointmentService.appointmentDetails.isOpenAppointment"
        [title]="!editAppointmentService.appointmentDetails.isOpenAppointment ? ('lblNeedToOpenAppointmentFromDMS' | translate) : ''"
        translate aria-label="Center Align">
        <em class="far fa-save font16 align-top mr-2"></em>lblReOpenAppointment
      </button>
      <a type="reset" class="btn btn-secondary btn-lg" (click)="CheckDataSyncedOnAppointment('close')" translate>
        <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
  </div>
</div>

<ng-template #reOpenAppointmentmodal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lblConfirm</h4>
    <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="modal-desc py-4 text-break" translate>lblAreYouSureWantToOpenAppointment</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary mr-sm-2" aria-label="Center Align"
      (click)="modal.dismiss(true)" translate>lblConfirm</button>
    <button type="button" class="btn btn-secondary" aria-label="Center Align"
      (click)="modal.dismiss(false)" translate>lblCancel</button>
  </div>
</ng-template>